// extracted by mini-css-extract-plugin
export default {"InputTextCopy":"InputTextCopy_InputTextCopy__GV-ny","InputText":"InputTextCopy_InputText__SmSxl","ToggleButton":"InputTextCopy_ToggleButton__8xDaB"};